import React, { useEffect, useState } from "react";
import { useAuth } from "../auth/AuthContext";
import { db } from "../firebase";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import ShippingFormLayout from "../Components/ShippingForm/ShippingFormLayout";

export default function EditAccountDetails() {
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const [form, setForm] = useState({
    fullName: "",
    phone: "",
    countryCode: "",
    state: "",
    city: "",
    address: "",
    postalCode: "",
    notes: "",
  });

  useEffect(() => {
    const loadDetails = async () => {
      try {
        if (!currentUser) return;

        const ref = doc(db, "users", currentUser.uid);
        const snap = await getDoc(ref);

        if (snap.exists()) {
          const shipping = snap.data().shippingInfo || {};
          setForm({
            fullName: shipping.fullName || "",
            phone: shipping.phone || "",
            countryCode: shipping.countryCode || "",
            state: shipping.state || "",
            city: shipping.city || "",
            address: shipping.address || "",
            postalCode: shipping.postalCode || "",
            notes: shipping.notes || "",
          });
        }
      } catch (err) {
        console.error(err);
        toast.error("Failed to load details");
      } finally {
        setLoading(false);
      }
    };

    loadDetails();
  }, [currentUser]);

  const handleChange = (e) => setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!currentUser) return;

    setSaving(true);
    try {
      await updateDoc(doc(db, "users", currentUser.uid), {
        shippingInfo: { ...form },
        updatedAt: new Date(),
      });

      toast.success("Details updated successfully");
      navigate("/my-account");
    } catch (err) {
      console.error(err);
      toast.error("Failed to update");
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return <main style={{ textAlign: "center", padding: 40 }}>Loading details...</main>;
  }

  if (!currentUser) {
    return (
      <main style={{ textAlign: "center", padding: 40 }}>
        <h2>Please log in</h2>
      </main>
    );
  }

  return (
<ShippingFormLayout
  title="Shipping Details"
  subtitle="Enter your shipping details to continue to checkout."
  form={form}
  onChange={handleChange}
  onSubmit={handleSubmit}
  saving={loading}
  submitText="Save Details"
  savingText="Saving..."
  centered
  card
/>
  );
}